import * as cx from 'classnames';
import { LOGOUT } from 'mk/autogenerated/translations/PhoneVerificationModal.1a121a9732564cd2b89c56c4b3e2bd70'
import { logout_url } from 'mk/urls/functions';
import Btn, { BtnType } from 'mk2/components/Btn';
import Modal from 'mk2/components/Modal';
import PhoneVerification from 'mk2/containers/PhoneVerification/PhoneVerification';
import { Mode } from 'mk2/containers/PhoneVerification/PhoneVerification.constants';
import {
    phoneVerificationModalClose,
    phoneVerificationModalShow,
} from 'mk2/containers/PhoneVerificationModal/PhoneVerificationModal.actions';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import {
    AppState,
    getPhoneVerificationModalMode,
    getPhoneVerificationModalOpened,
    getRequestPhoneVerificationMode,
} from 'mk2/reducers';
import * as React from 'react';
import { connect } from 'react-redux';
import styles from './PhoneVerificationModal.mscss';

interface OwnProps {
    className?: string;
}

interface StateProps {
    requestMode: 'newuser' | 'forced' | null;
    mode: Mode;
    show: boolean;

}

interface DispatchProps {
    onClose();
    onOpen(requestMode: Mode);
}

type Props = OwnProps & StateProps & DispatchProps;

class PhoneVerificationModal extends React.Component<Props> {

    public componentWillMount() {
        const { show, requestMode, onOpen } = this.props;
        if (requestMode && !show) {
            onOpen(this.props.requestMode);
        }
    }

    public render() {
        const { className, show, mode, onClose } = this.props;

        if (!show) {
            return null;
        }

        return (
            <Modal show={show} className={cx(styles.PhoneVerificationModal, className)}>
                <div className={cx(styles.PhoneVerificationModal__body, styles[`PhoneVerificationModal__body--${mode}`])}>
                    <PhoneVerification mode={mode} />

                    <div className={styles.PhoneVerificationModal__body__close}>
                        {mode === 'forced' || mode === 'newuser' ? (
                            <Btn
                                type={BtnType.Link}
                                label={<span dangerouslySetInnerHTML={{ __html: LOGOUT }} />}
                                asAnchor
                                link={logout_url()}
                            />
                        ) : (
                            <div className={styles.PhoneVerificationModal__body__close__button} onClick={onClose}>
                                <i className="fa fa-times-circle" />
                            </div>
                        )}
                    </div>
                </div>
            </Modal>
        );
    }

}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    return {
        requestMode: getRequestPhoneVerificationMode(state),
        mode: getPhoneVerificationModalMode(state),
        show: getPhoneVerificationModalOpened(state),
    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
    onClose: phoneVerificationModalClose,
    onOpen: phoneVerificationModalShow,
};

export default connect(mapStateToProps, mapDispatchToProps)(PhoneVerificationModal);
